<script>
//import API from "../api/API";
export default {
  name: "Mixin",
  methods: {
    GoToPathHome() {
      // this.$router.push({ path: "/" });
      this.$router.go(0)
    },
    
  }
};
</script>

